<div class="layout-footer">
  <img
    src="assets/images/logo-vsdigital-footer.png"
    alt="VS Agenda"
    class="w-6rem flex-shrink-0"
  />
</div>
